"use client";

import { useEffect } from "react";
import { cleanupOldEntries } from "@/utils/backUrlStorage";

export default function BackUrlCleanup() {
  useEffect(() => {
    // Cleanup entries older than 7 days on app load
    cleanupOldEntries(7);
  }, []);

  return null;
}

